<template>
    <el-table
        :data="data"
        ref="table"
        :empty-text="emptyText"
        class="tax-data-table invoice"
        v-loading="isLoading"
        :default-sort="{ prop: 'foO_DAT', order: 'ascending' }"
        :height="tableHeight"
        :key="tableKey"
        @select="onSelect"
        @select-all="onSelectAll"
        @sort-change="onSortChange"
    >
        <el-table-column key="index" fixed label="#" type="index" :index="getIndex" width="40" class-name="td_index"></el-table-column>
        <el-table-column key="selection" fixed type="selection" width="45"></el-table-column>
        <el-table-column prop="declareStatus" label="申報狀態" width="100" sortable>
            <template slot-scope="scope">
                <span class="declare-status">
                    <span>{{ getDeclaredText(scope.row) }}</span>
                </span>
            </template>
        </el-table-column>
        <el-table-column key="period" prop="period" label="申報期別" width="160" v-if="showPeriod">
            <template slot-scope="scope">
                <div v-if="isStatusChangeable(scope.row) && scope.row.prefiX_MONTH">
                    <span>{{ getPeriodText(scope.row.prefiX_YER, scope.row.prefiX_MONTH) }}</span>
                </div>
            </template>
        </el-table-column>
        <el-table-column prop="foO_DAT" label="發票日期" width="105" sortable>
            <template slot-scope="scope">
                <div>
                    {{ scope.row.foO_DAT | dateFormater("YYYY-MM-dd") }}
                </div>
            </template>
        </el-table-column>
        <el-table-column key="typ" prop="typ" label="發票類型" align="left" width="140" sortable>
            <template slot-scope="scope">
                <div>
                    {{ getInvoiceTypeText(scope.row.typ) }}
                </div>
            </template>
        </el-table-column>
        <el-table-column key="foo" prop="foo" label="發票號碼" width="150" sortable>
            <template slot-scope="scope">
                <div>
                    <span v-if="scope.row.foO_DIS_CNL || scope.row.foO_CNL" class="cnl-label">作廢</span>
                    <ahReceiptNumber :v="scope.row.foo" />
                </div>
                <!-- <div v-if="checkNumberDuplicate(scope.row)" class="duplicate-item">重複</div> -->
            </template>
        </el-table-column>
        <el-table-column key="code" prop="code" width="130">
            <template slot="header">格式代號</template>
            <template v-if="scope.row.typ !== 1" slot-scope="scope">
                <div v-if="isNormalDataRow(scope.row) && isStatusChangeable(scope.row)" style="display: flex; align-items: center">
                    <el-select
                        :value="Number(scope.row.code)"
                        size="mini"
                        placeholder="請選擇"
                        style="width: 90px"
                        :disabled="!isCodeAvailable(scope.row)"
                        @input="onItemCodeInput(scope.row.sno, $event, scope.row.taxCredited, scope.row.isTranInovice)"
                    >
                        <el-option v-for="item in codeOptions" :key="item.value" :label="item.label" :value="item.value">
                            <span style="margin-bottom: 0; padding-right: 15px">{{ item.label }}</span>
                            <span style="color: #8492a6; font-size: 13px; margin-top: -10px">{{ item.info }}</span>
                        </el-option>
                    </el-select>
                    <el-tooltip v-if="onCheckCode(scope.row)" effect="dark" placement="top" :content="onCheckCode(scope.row)">
                        <span class="icon el-icon-warning" style="display: inline-block; color: #ffba00; margin-left: 5px"></span>
                    </el-tooltip>
                </div>
                <div v-else>
                    {{ scope.row.code || "--" }}
                    <el-tooltip v-if="scope.row.foo && !scope.row.code" effect="dark" placement="top" content="本期查無對應發票字軌，請確認發票日期、字軌號碼是否正確。">
                        <span class="icon el-icon-warning" style="display: inline-block; color: #ffba00; margin-left: 5px"></span>
                    </el-tooltip>
                </div>
            </template>
        </el-table-column>
        <el-table-column key="nonTaxAmt" prop="nonTaxAmt" label="銷售額(未稅)" align="right" width="120" sortable>
            <template slot-scope="scope">
                <Money :v="scope.row.amt - scope.row.amT_TAX" />
            </template>
        </el-table-column>
        <el-table-column key="tax" prop="tax" label="稅額" align="right" width="100" sortable>
            <template slot-scope="scope">
                <Money :v="scope.row.amT_TAX" />
            </template>
        </el-table-column>
        <el-table-column key="amt" prop="amt" label="含稅總額" align="right" width="120" sortable>
            <template slot-scope="scope">
                <Money :v="scope.row.amt" />
            </template>
        </el-table-column>
        <el-table-column key="companyName" prop="companyName" label="買方公司" min-width="115" :show-overflow-tooltip="true" sortable></el-table-column>
        <el-table-column v-if="data.length > 0" key="bsn" prop="bsn" label="買方統編" width="110" sortable></el-table-column>
        <el-table-column v-if="data.length > 0" key="ioo" prop="ioo" label="來源發票" width="115" sortable>
            <template slot-scope="scope">
                <el-button v-if="scope.row.isTranInovice" type="text" @click="$emit('open', scope.row.tioo, 1, true)">
                    {{ scope.row.tioo }}
                </el-button>
                <el-button v-else type="text" @click="$emit('open', scope.row.sno)">
                    {{ scope.row.ioo }}
                </el-button>
            </template>
        </el-table-column>
        <el-table-column v-if="data.length > 0" key="foO_DIS_Declared" prop="foO_DIS_Declared" label="退回/折讓申報" width="150" sortable>
            <template slot-scope="scope">
                <span v-if="scope.row.typ !== -1 && scope.row.foO_DIS_DAT && scope.row.foO_DIS_Declared"> 已申報 </span>
            </template>
        </el-table-column>
        <el-table-column v-if="data.length > 0" key="foO_DIS_AMT" prop="foO_DIS_AMT" label="退回/折讓金額" align="right" width="150" sortable>
            <template slot-scope="scope">
                <el-tooltip
                    v-if="scope.row.typ !== -1 && !scope.row.foO_DIS_CNL && scope.row.foO_DIS_AMT > 0"
                    class="item"
                    size="small"
                    effect="dark"
                    :content="getDiscountText(scope.row.foO_DIS)"
                    placement="top"
                >
                    <Money :v="scope.row.foO_DIS_AMT" style="color: red" />
                </el-tooltip>
            </template>
        </el-table-column>
        <el-table-column v-if="data.length > 0" key="foO_DIS_DAT" prop="foO_DIS_DAT" label="退回/折讓日期" align="right" width="150" sortable>
            <template slot-scope="scope">
                <span v-if="scope.row.typ !== -1 && !scope.row.foO_DIS_CNL">
                    {{ scope.row.foO_DIS_DAT | dateFormater("YYYY-MM-dd") }}
                </span>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { mapState, mapMutations, mapActions } from 'vuex';
import ahReceiptNumber from '@/components/ui/ahReceiptNumber.vue';
import invoiceSerialNumber from '@/assets/commonData/invoiceSerialNumber';
import { invoiceCodeOptions } from './CodeOptions';

export default {
    components: { ahReceiptNumber },
    props: {
        showPeriod: {
            type: Boolean,
            default: true,
        },
        paginationHeight: {
            type: Number,
            default: 50,
        },
    },
    data() {
        return {
            tableHeight: 0,
            tableKey: 1,
        };
    },
    computed: {
        ...mapState({
            periodList: (state) => state.businessTax.periodList,
            isLoading: (state) => state.businessTax.isLoading,
            data: (state) => state.businessTax.datas,
            queryParams: (state) => state.businessTax.queryParams,
            selectedItems: (state) => state.businessTax.selectedItems,
            declaredInvoiceItems: (state) => state.businessTax.declaredInvoiceItems,
        }),
        codeOptions() {
            return invoiceCodeOptions;
        },
        emptyText() {
            return this.declaredInvoiceItems.length && !this.data.length ? '本期已申報完畢' : '本期無資料';
        },
    },
    methods: {
        ...mapMutations({
            setCurrentTableVueComponent: 'businessTax/setCurrentTableVueComponent',
            onSelect: 'businessTax/onSelect',
            onSelectAll: 'businessTax/onSelectAll',
        }),
        ...mapActions({
            updateData: 'businessTax/updateData',
        }),
        isStatusChangeable(row) {
            return row.typ !== 1 && row.typ !== 4 && row.tax === 1;
        },
        resizeTableLayout() {
            const pageHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            const tableY = this.$refs.table.$el.getBoundingClientRect().top;
            const tableHeight = pageHeight - tableY - this.paginationHeight;
            this.tableHeight = tableHeight;
        },
        isExportable(row) {
            return !((row.typ === 3 && !row.bsn) || !row.foo || row.typ === 1);
        },

        // ======================== 新增Function =============================

        getDeclaredText(row) {
            if (this.isStatusChangeable(row)) {
                const value = row.typ < 0 ? row.foO_DIS_Declared : row.declared;
                return value ? '已申報' : '未申報';
            }

            if (row.tax === 2) return '零稅率';

            if (row.tax === 3) return '未申報'; // 免稅，要申報

            return '免申報';
        },

        // ======================== DataTableMixins =============================
        fetchSelection(sel) {
            sel.forEach((item) => {
                const SEL = _.find(this.data, (o) => o.sno === item.sno && o.typ === item.typ);
                if (SEL) {
                    this.$nextTick(() => {
                        this.$refs.table.toggleRowSelection(SEL);
                    });
                }
            });
        },
        onSortChange(event) {
            this.$emit('onSortChange', event);
        },
        getPeriodText(year, month) {
            const PERIOD_OBJECT = _.find(this.periodList, { year, value: month });
            return PERIOD_OBJECT ? `${PERIOD_OBJECT.year - 1911}年 ${PERIOD_OBJECT.period}` : '尚未申報';
        },
        checkNumberDuplicate(row) {
            if (!row.foo) return false;
            return _.find(this.data, (o) => o.sno !== row.sno && o.foo === row.foo);
        },
        getInvoiceTypeText(typ) {
            if (typ === -1) return '折讓';
            if (typ === 1) return 'INVOICE';
            if (typ === 2) return '二聯式發票';
            if (typ === 3) return '三聯式發票';
            if (typ === 4) return '核銷';
            return '';
        },
        getDiscountText(typ) {
            if (typ === 0) return '無折讓';
            if (typ === 1) return '部分折讓';
            if (typ === 2) return '全部折讓';
            return '';
        },
        isNormalDataRow(row) {
            return row.typ > 0 || !row.typ;
        },
        isCodeAvailable(row) {
            // if (!row.typ && row.declareStatus === 1) return false;
            // if (row.typ > 0 && row.declared) return false;
            // if (row.typ < 0 && row.foO_DIS_Declared) return false;
            // if (this.selectedItems.find((o) => o.declared || o.declareStatus === 1)) return !this.selectedItems.includes(row);
            return true;
        },
        onCheckCode(item) {
            if (!item.foo) return undefined;
            const validateCode = this.getValidateCode(item);
            if (validateCode) {
                // eslint-disable-next-line eqeqeq
                const validate = item.code == validateCode;
                return validate ? undefined : '與要求之格式代號不符，請確認發票日期、字軌號碼是否正確。';
            }

            return '本期查無對應發票字軌，請確認發票日期、字軌號碼是否正確。';
        },
        getValidateCode(item) {
            if (item.typ < 0) return undefined;
            if (item.filE_TYP === 11) return 22;

            const isIncome = item.typ !== undefined;
            const fooMonth = moment(item.foO_DAT).month() + 1;
            const fooYear = moment(item.foO_DAT).year();
            const fooKey = `${item.foo[0]}${item.foo[1]}`;
            const TYPE = _.chain(invoiceSerialNumber)
                .filter(['year', fooYear])
                .find((o) => o.month.includes(fooMonth))
                .get('datas')
                .find((o) => o.serialNumbers.includes(fooKey))
                .get('name')
                .value();

            const isCashierTripleInvoice = item.filE_TYP === 10;
            const TYPE_CODE = { A: 1, B: 2, D: 5 };
            if (TYPE) {
                return `${isIncome ? 3 : 2}${isCashierTripleInvoice ? 5 : TYPE_CODE[TYPE]}`;
            }
            return undefined;
        },
        async onItemCodeInput(sno, code, isTCIN, isTranInovice) {
            try {
                // 發送更新Api
                if (isTCIN) {
                    const resp = await this.$api({
                        url: 'AccountingSummaryPage/UpdatePayInvoice401Code',
                        data: {
                            updateType: this.queryParams.QueryType,
                            code401s: [{ sno, code }],
                        },
                        method: 'POST',
                    });
                    console.log('UpdateTCIN401Code', resp);
                } else if (isTranInovice) {
                    const resp = await this.$api({
                        url: 'AccountingSummaryPage/Update401Code',
                        data: {
                            updateType: 5,
                            code401s: [{ sno, code }],
                        },
                        method: 'POST',
                    });
                    console.log('Tran Update401Code', resp);
                } else {
                    const resp = await this.$api({
                        url: 'AccountingSummaryPage/Update401Code',
                        data: {
                            updateType: this.queryParams.QueryType,
                            code401s: [{ sno, code }],
                        },
                        method: 'POST',
                    });
                    console.log('Update401Code', resp);
                }

                // 更新LocalStorage
                const LOCAL_DATA_NAME = this.queryParams.QueryType === 1 ? '401-selected-invoice' : '401-selected-payment';
                const LOCAL_DATA = JSON.parse(window.localStorage.getItem(LOCAL_DATA_NAME)) || [];
                const FOUND_INDEX = _.findIndex(LOCAL_DATA, ['sno', sno]);

                if (FOUND_INDEX >= 0) {
                    const dataChanged = LOCAL_DATA[FOUND_INDEX];
                    dataChanged.code = code;
                    window.localStorage.setItem(LOCAL_DATA_NAME, JSON.stringify(LOCAL_DATA));
                }

                // 更新列表
                this.updateData();
            } catch (e) {
                console.log(e);
            }
        },

        getIndex(val) {
            return this.queryParams.PageSize * (this.queryParams.PageNum - 1) + val + 1;
        },
    },
    mounted() {
        this.setCurrentTableVueComponent(this);

        this.resizeTableLayout();
        const { table } = this.$refs;
        setTimeout(() => {
            this.tableKey += 1;
            table.key = this.tableKey;
        }, 2);

        window.addEventListener('resize', this.resizeTableLayout);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeTableLayout);
    },
};
</script>

<style lang="scss">
@import "./common-style.scss";
</style>
